import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import App from './App';
import * as serviceWorker from './serviceWorker';
import { createBrowserHistory, History } from 'history';
import moment from "moment";
import './fonts/typeface-lato/index.css';

require('moment/locale/nn.js');

// import './assets/css/fonts.css';
export const API_URL = process && process.env && process.env.REACT_APP_API;

export const myHistory: History = createBrowserHistory();

Sentry.init({
    dsn: "https://326cd09fa9844ac2b785c348f72dc5ce@o503737.ingest.sentry.io/5948963",
    integrations: [new Integrations.BrowserTracing()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
});

moment.locale('nn');

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
